import { render, staticRenderFns } from "./assign-role.vue?vue&type=template&id=a4077b46&scoped=true&style=padding-left%3A100px%3B&"
import script from "./assign-role.vue?vue&type=script&lang=js&"
export * from "./assign-role.vue?vue&type=script&lang=js&"
import style0 from "./assign-role.vue?vue&type=style&index=0&id=a4077b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4077b46",
  null
  
)

export default component.exports